import React, { useEffect } from 'react';
import Layout from '../components/Layout';

/**
 * Dashboard component - main page after successful login
 */
const Dashboard = () => {
  useEffect(() => {
    document.title = 'Dashboard - Mappy';
  }, []);

  return (
    <Layout>
      <div className="container mx-auto p-6 space-y-6">
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
      </div>
    </Layout>
  );
};

export default Dashboard;
